import React, { useState, useEffect } from "react";
import { Overview } from "@/views/Agenda/Overview";
import EventItem from '@/views/Agenda/EventItem'
import DossierItem from '@/views/Agenda/DossierItem'
import ScheduleDossierItem from "./ScheduleDossierItem";
import ScheduleCalender from "./ScheduleCalender";
import store from "@/redux/store";
import {saveScheduleTasks2} from '@/reducers/Schedule';
import {setItemForSchedule, createTaskForScheduleItem, getUserSchedules, cancelSchedule} from '@/reducers/CommunicationCycle';
import {PlanView} from "./PlanView";

import {show, hide, MODAL_TYPE} from '@/reducers/ModalReducer';
import CompleetScheduleTasks from '@/components/timeline/view/modals/view/CompleetScheduleTasks';

export function ScheduleView({...props}) {
    const [scheduleItems, setScheduleItems] = useState(null);
//    const { t, i18n, ready } = useTranslation();
// <ScheduleCalender key={(scheduleItems?.updateKey) ? scheduleItems?.updateKey : "KDM"} items={scheduleItems} {...props}/>
useEffect(() => {
if(!scheduleItems) {
    onUserSelectHandler({});
}
}, [scheduleItems]);

useEffect(() => {
    
}, [props?.dossierScheduleItems]);

const onEventItemClickEvent = (event, day) => {
    store.dispatch( createTaskForScheduleItem({}) );
//createTaskForScheduleItem
}

const onUserSelectHandler = (data) => {
    store.dispatch( getUserSchedules(data) );
return;    
    //store.dispatch( createTaskForScheduleItem({}) );
    return false;
//createTaskForScheduleItem
}      

const onCancelEventHandler=(event) => {
    const {onCancelEvent, dossierScheduleItems} = props;
    store.dispatch( cancelSchedule({}) );
    if(onCancelEvent) {
        onCancelEvent(event);
    }    
    return false;
    
}

const onCloseEventHandler=(event, compleet) => {
    const {onCloseEvent, dossierScheduleItems} = props;
        event.preventDefault();
        event.stopPropagation();
        
        if(compleet == 1) {
            
    store.dispatch( show({modalType: MODAL_TYPE.COMPLEET_PLANBOARDTASKS, data: dossierScheduleItems, options: {
        body: (<CompleetScheduleTasks  succesEventHandler={storeAndClose} data={dossierScheduleItems} />)
        
    } }) );
        return;            
            
        }
        
      storeAndClose(event, compleet);  
    return false;
    store.dispatch( saveScheduleTasks2({...dossierScheduleItems, dossierKey: props?.dossier?.key, compleet:compleet}) );
    
    if(onCloseEvent) {
        onCloseEvent(event);
    }    
}

const storeAndClose=(event, compleet) => {
    const {onCloseEvent, dossierScheduleItems} = props;

    store.dispatch( saveScheduleTasks2({...dossierScheduleItems, dossierKey: props?.dossier?.key, compleet:compleet}) );
    
//    if(compleet == 1) {
        store.dispatch( hide(null) );        
//    }
    
    if(onCloseEvent) {
        onCloseEvent(event);
    }    
    return false;
    
}
      
        return (
        <>
        <div className="relative isolate w-full h-screen grid grid-cols-12  md:grid-cols-12">
        <div className="mx-auto mt-5 col-span-12 w-[inherit]">
            <div className="w-auto p-5">

    <div className="md:flex md:items-center md:justify-between">
      <div className="min-w-0 flex-1">
        <h2 className="text-2xl/7 font-bold text-gray-900 sm:truncate sm:text-3xl sm:tracking-tight">
          Dossier : {props?.dossier?.name}
        </h2>
      </div>
      <div className="mt-4 flex md:mt-0 md:ml-4">
        <button onClick={(event) => onCancelEventHandler(event)}
          type="button"
          className="inline-flex items-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 ring-1 shadow-xs ring-gray-300 ring-inset hover:bg-gray-50"
        >
          Annuleren
        </button>
        <button onClick={(event) => onCloseEventHandler(event, 1)}
          type="button"
          className="ml-3 inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Planning definitief maken
        </button>
        
        <button onClick={(event) => onCloseEventHandler(event, 0)}
          type="button"
          className="ml-3 inline-flex items-center rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-xs hover:bg-indigo-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
        >
          Bewaren en sluiten
        </button>
      </div>
    </div>            
            <PlanView key={props?.refreshKey} selectedTask={props?.selectedTask}  tasks={props?.items} dossier={props?.items} users={props?.users} dossierScheduleItems={props?.dossierScheduleItems} userScheduleItems={props?.userScheduleItems} />
            </div>                  
        </div>
        </div>
        </>
    )

}